import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { EditPartnerRequestType } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { PartnerBasicInfo } from 'clickNgo/entities/partner/ui/partnerBasicInfo'
import { useGetFormDataField } from 'cng-common/features/form'

import {
  PARTNER_DATA_FORM_KEYS,
  PartnerDataFormKeys,
  PartnerDataFormSettings,
  READ_ONLY_BASIC_INFO_FIELDS,
} from '../../configs'
import { PartnerDataFormContainer } from '../partnerDataFormContainer/PartnerDataFormContainer'
import { PartnerWorkflowStatusPanel } from '../partnerWorkflowStatusPanel/PartnerWorkflowStatusPanel'

import { useBasicInfoMandatoryAttachments } from './hooks/useBasicInfoMandatoryAttachments'
import { useEditPartnerBasicInfoHandler } from './hooks/useEditPartnerBasicInfoHandler'
import { usePartnerBasicInfoValidation } from './hooks/usePartnerBasicInfoValidation'

interface IPartnerBasicInfoWrapper {
  partner: IPartner
  isDisabled?: boolean
  isSaveAsDraft: boolean
}

export const PartnerBasicInfoWrapper = ({
  partner,
  isDisabled,
  isSaveAsDraft,
}: IPartnerBasicInfoWrapper) => {
  const { basicValidationProps } = usePartnerBasicInfoValidation({
    formKeys: PARTNER_DATA_FORM_KEYS,
  })

  const { handleOnPartnerBasicChangesApply, handleOnPartnerBasicChangesCancel } =
    useEditPartnerBasicInfoHandler({ partner })

  const { isAttachmentRequired } = useBasicInfoMandatoryAttachments({
    hasActiveAgreement: partner.hasActiveAgreement,
  })
  const [isInactive] = useGetFormDataField<boolean>(
    PartnerDataFormKeys.Setting,
    PartnerDataFormSettings.IsInactive
  )

  return (
    <PartnerDataFormContainer
      formKey={PartnerDataFormKeys.BasicInfo}
      onApply={handleOnPartnerBasicChangesApply}
      onCancel={handleOnPartnerBasicChangesCancel}
      isAttachmentRequired={isAttachmentRequired}
      isSaveAsDraft={isSaveAsDraft}
    >
      <RenderWhen condition={!isInactive}>
        <PartnerWorkflowStatusPanel
          type={EditPartnerRequestType.BASIC}
          entryId={partner.entryId406}
          workflowStatus={partner.workflowStatus}
          partnerId={partner.partnerId}
          isDisabled={isDisabled}
        />
      </RenderWhen>
      <PartnerBasicInfo
        {...partner}
        {...basicValidationProps}
        isReadOnly={isDisabled}
        formKeys={PARTNER_DATA_FORM_KEYS}
        readOnlyFields={READ_ONLY_BASIC_INFO_FIELDS}
      />
    </PartnerDataFormContainer>
  )
}
